import { z } from 'zod';

export const zodUpdateCurrentParsedInvoiceEndpointSchema = z.tuple([
  z.literal('invoice'),
  z.literal('process'),
  z.uuid(),
  z.literal('current_parsed_invoice'),
]);

export const zodUpdateCurrentParsedInvoicePayloadSchema = z.looseObject({
  // FIXME: add validation
}); // FIXME: add validation
